<template>
  <v-dialog v-model="cambiarClave.open" width="500px">
    <v-card>
      <v-card-title class="grey lighten-4 py-4 title">
        Cambiar clave
      </v-card-title>
      <v-container grid-list-sm class="pa-4">
        <v-layout row wrap>
          <v-flex xs12 align-center justify-space-between>
            <v-layout align-center>
              <v-text-field label="Clave actual" type="password"></v-text-field>
            </v-layout>
          </v-flex>
          <v-flex xs12 align-center justify-space-between>
            <v-layout align-center>
              <v-text-field label="Nueva clave" type="password"></v-text-field>
            </v-layout>
          </v-flex>
          <v-flex xs12 align-center justify-space-between>
            <v-layout align-center>
              <v-text-field label="Repetir nueva clave" type="password"></v-text-field>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="cambiarClave.open = false">Cancelar</v-btn>
        <v-btn flat @click="cambiarClave.open = false">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'cambiar-clave',
  props: ['cambiarClave'],
  methods: {
    cambiarClaveForm: function (event) {
      self.cambiarClave = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CambiarClave.vue